<template>
    <!--
    	作者：bbc_team
    	时间：2023-06-08
    	描述：商品管理-商品编辑-规格/库存-多规格-表格
    -->
    <div class="mt16">
        <el-form-item v-if="form.model.spec_many && form.model.spec_many.spec_list.length > 0" label="规格明细：">
            <div>
                批量设置
                <el-input v-model="batchData.goods_price" size="small" placeholder="销售价" style="width: 160px;padding-left: 4px;"></el-input>
                <el-input v-model="batchData.line_price" size="small" placeholder="划线价" style="width: 160px;padding-left: 4px;"></el-input>
                <el-input v-model="batchData.stock_num" size="small" placeholder="库存" style="width: 160px;padding-left: 4px;"></el-input>
                <el-input v-model="batchData.goods_weight" size="small" placeholder="重量" style="width: 160px;padding-left: 4px;"></el-input>
                <el-input v-model="batchData.cunzan_coin" size="small" placeholder="村赞币价格" style="width: 160px;padding-left: 4px;"></el-input>
                <el-input v-model="batchData.settlement_price" size="small" placeholder="结算价格" style="width: 160px;padding-left: 4px;"></el-input>
                <el-input v-model="batchData.package_num" size="small" placeholder="小包装数" style="width: 160px;padding-left: 4px;"></el-input>
                <el-input v-model="batchData.address_price" size="small" placeholder="新增地址单价" style="width: 160px;padding-left: 4px;"></el-input>
                <el-button size="small" @click="onSubmitBatchData">应用</el-button>
            </div>
            <!--多规格表格-->
            <div>
                <el-table size="mini" :data="form.model.spec_many.spec_list" :span-method="objectSpanMethod" border style="width: 100%; margin-top: 20px">
                    <el-table-column v-for="(item, index) in form.model.spec_many.spec_attr" :key="item.group_name" :label="item.group_name">
                        <template slot-scope="scope">
                            {{ scope.row.rows[index].spec_value }}
                        </template>
                    </el-table-column>
                    <el-table-column label="规格图片">
                        <template slot-scope="scope">
                            <div class="draggable-list">
                                <div v-if="scope.row.spec_form.image_path == ''" class="item img-select" style="width: 50px; height: 50px;" @click="chooseSpecImage(scope.$index)"><i class="el-icon-plus"></i></div>
                                <div v-else class="item" style="width: 50px;height: 50px;">
                                    <el-image :src="scope.row.spec_form.image_path" :preview-src-list="[scope.row.spec_form.image_path]" style="width: 50px; height: 50px;"></el-image>
                                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(scope.$index)"><i class="el-icon-close"></i></a>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="产品编码">
                        <template slot-scope="scope">
                            <el-form-item label="" style="margin-bottom: 0;"><el-input v-model="scope.row.spec_form.goods_no" size="small" prop="goods_no"></el-input></el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="销售价">
                        <template slot-scope="scope">
                            <el-form-item label="" :rules="[{ required: true, message: ' ' }]" :prop="'model.spec_many.spec_list.' + scope.$index + '.spec_form.goods_price'" style="margin-bottom: 0;">
                                <el-input v-model="scope.row.spec_form.goods_price" size="small" prop="goods_price"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="划线价">
                        <template slot-scope="scope">
                            <el-form-item label="" style="margin-bottom: 0;"><el-input v-model="scope.row.spec_form.line_price" size="small" prop="line_price"></el-input></el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="库存">
                        <template slot-scope="scope">
                            <el-form-item label="" :rules="[{ required: true, message: ' ' }]" :prop="'model.spec_many.spec_list.' + scope.$index + '.spec_form.stock_num'" style="margin-bottom: 0;">
                                <el-input v-model="scope.row.spec_form.stock_num" size="small" prop="stock_num"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="重量(kg)">
                        <template slot-scope="scope">
                            <el-form-item
                                label=""
                                :rules="[{ required: true, message: ' ' }]"
                                :prop="'model.spec_many.spec_list.' + scope.$index + '.spec_form.goods_weight'"
                                style="margin-bottom: 0;"
                            >
                                <el-input v-model="scope.row.spec_form.goods_weight" size="small" prop="goods_weight"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="村赞币价格">
                        <template slot-scope="scope">
                            <el-form-item label="" style="margin-bottom: 0;"><el-input v-model="scope.row.spec_form.cunzan_coin" size="small" prop="cunzan_coin"></el-input></el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="结算价格">
                        <template slot-scope="scope">
                            <el-form-item label="" style="margin-bottom: 0;"><el-input v-model="scope.row.spec_form.settlement_price" size="small" prop="settlement_price"></el-input></el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="小包装数">
                        <template slot-scope="scope">
                            <el-form-item label="" style="margin-bottom: 0;"><el-input v-model="scope.row.spec_form.package_num" size="small" prop="package_num"></el-input></el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="新增地址单价">
                        <template slot-scope="scope">
                            <el-form-item label="" style="margin-bottom: 0;"><el-input v-model="scope.row.spec_form.address_price" size="small" prop="address_price"></el-input></el-form-item>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-form-item>
        <!--上传图片组件-->
        <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
    </div>
</template>

<script>
    import GoodsApi from "@/api/goods.js";
    import Upload from "@/components/file/Upload";
    export default {
        components: {
            Upload
        },
        inject: ["form"],
        data() {
            return {
                /*批量设置sku属性*/
                batchData: {
                    goods_price: "",
                    line_price: "",
                    stock_num: "",
                    goods_weight: "",
                    cunzan_coin: "",
                    settlement_price: "",
                    package_num: "",
                    address_price: "",
                },
                /*图片是否打开*/
                isupload: false,
                //上传图片选择的下标
                spec_index: -1
            };
        },
        created() {},
        methods: {
            /*表格跨行*/
            objectSpanMethod({ row, column, rowIndex, columnIndex }) {
                var spec_attr = this.form.model.spec_many.spec_attr;
                // 规格组合总数 (table行数)
                var totalRow = 1;
                //比如2个规格,只有第一列有多行
                if (columnIndex < spec_attr.length - 1) {
                    let startRowIndex = columnIndex + 1;
                    let endRowIndex = spec_attr.length - 1;
                    for (var i = startRowIndex; i <= endRowIndex; i++) {
                        totalRow *= spec_attr[i].spec_items.length;
                    }
                    if (rowIndex % totalRow === 0) {
                        return {
                            rowspan: totalRow,
                            colspan: 1
                        };
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    }
                }
            },

            /*批量设置sku属性*/
            onSubmitBatchData: function() {
                var self = this;
                self.form.model.spec_many.spec_list.forEach(function(value) {
                    for (var key in self.batchData) {
                        if (self.batchData.hasOwnProperty(key) && self.batchData[key]) {
                            self.$set(value.spec_form, key, self.batchData[key]);
                        }
                    }
                });
            },

            /*选择图片*/
            chooseSpecImage: function(spec_index) {
                this.isupload = true;
                this.spec_index = spec_index;
            },
            deleteImg(index){
                this.form.model.spec_many.spec_list[index].spec_form.image_id = 0;
                this.form.model.spec_many.spec_list[index].spec_form.image_path = '';
            },

            /*返回图片*/
            returnImgsFunc(e) {
                this.isupload = false;
                this.$set(this.form.model.spec_many.spec_list[this.spec_index].spec_form, "image_id", e[0]["file_id"]);
                this.$set(this.form.model.spec_many.spec_list[this.spec_index].spec_form, "image_path", e[0]["file_path"]);
            }
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/goods/goods/part/spec/many/Table.vue